import type { MealLogEntry } from '../mealLog/types'
import type { MealCookActivity } from './types'

// Per-meal cooking activity from the cook log: only cooked entries count, and the latest one dates it.
export function deriveCookActivity(entries: readonly MealLogEntry[]): Map<string, MealCookActivity> {
  const byMeal = new Map<string, MealCookActivity>()
  for (const entry of entries) {
    if (!entry.cooked) continue
    const prev = byMeal.get(entry.mealId)
    byMeal.set(entry.mealId, {
      cookCount: (prev?.cookCount ?? 0) + 1,
      lastCookedAt: prev?.lastCookedAt && prev.lastCookedAt > entry.createdAt ? prev.lastCookedAt : entry.createdAt
    })
  }
  return byMeal
}
